module.exports = __webpack_public_path__ + "e2520228a0dacbe6aa4445251cb1dc76.mp4";